import { Component, Directive, Input, Output, TemplateRef, ViewContainerRef, ContentChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { TemplatePortalDirective } from '@angular/material';

import { TdCollapseAnimation } from '../common/common.module';
export class TdExpansionPanelHeaderDirective extends TemplatePortalDirective {
/**
 * @param {?} templateRef
 * @param {?} viewContainerRef
 */
constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[td-expansion-panel-header]ng-template',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}

function TdExpansionPanelHeaderDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdExpansionPanelHeaderDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdExpansionPanelHeaderDirective.ctorParameters;
}

export class TdExpansionPanelLabelDirective extends TemplatePortalDirective {
/**
 * @param {?} templateRef
 * @param {?} viewContainerRef
 */
constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[td-expansion-panel-label]ng-template',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}

function TdExpansionPanelLabelDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdExpansionPanelLabelDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdExpansionPanelLabelDirective.ctorParameters;
}

export class TdExpansionPanelSublabelDirective extends TemplatePortalDirective {
/**
 * @param {?} templateRef
 * @param {?} viewContainerRef
 */
constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[td-expansion-panel-sublabel]ng-template',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}

function TdExpansionPanelSublabelDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdExpansionPanelSublabelDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdExpansionPanelSublabelDirective.ctorParameters;
}

export class TdExpansionPanelSummaryComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'td-expansion-summary',
  template: '<ng-content></ng-content>',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdExpansionPanelSummaryComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdExpansionPanelSummaryComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdExpansionPanelSummaryComponent.ctorParameters;
}

export class TdExpansionPanelComponent {
private _expand: boolean = false;
private _disabled: boolean = false;

   expansionPanelHeader: TdExpansionPanelHeaderDirective;
   expansionPanelLabel: TdExpansionPanelLabelDirective;
   expansionPanelSublabel: TdExpansionPanelSublabelDirective;
/**
 * label?: string
 * Sets label of [TdExpansionPanelComponent] header.
 * Defaults to 'Click to expand'
 */
label: string;
/**
 * sublabel?: string
 * Sets sublabel of [TdExpansionPanelComponent] header.
 */
sublabel: string;
/**
 * expand?: boolean
 * Toggles [TdExpansionPanelComponent] between expand/collapse.
 * @param {?} expand
 * @return {?}
 */
set expand(expand: boolean) {
    this._setExpand(expand);
  }
/**
 * @return {?}
 */
get expand(): boolean {
    return this._expand;
  }
/**
 * disabled?: boolean
 * Disables icon and header, blocks click event and sets [TdStepComponent] to deactive if 'true'.
 * @param {?} disabled
 * @return {?}
 */
set disabled(disabled: boolean) {
    if (disabled && this._expand) {
      this._expand = false;
      this._onCollapsed();
    }
    this._disabled = disabled;
  }
/**
 * @return {?}
 */
get disabled(): boolean {
    return this._disabled;
  }
/**
 * expanded?: function
 * Event emitted when [TdExpansionPanelComponent] is expanded.
 */
expanded: EventEmitter<void> = new EventEmitter<void>();
/**
 * collapsed?: function
 * Event emitted when [TdExpansionPanelComponent] is collapsed.
 */
collapsed: EventEmitter<void> = new EventEmitter<void>();
/**
 * Method executed when [TdExpansionPanelComponent] is clicked.
 * @return {?}
 */
clickEvent(): void {
    this._setExpand(!this._expand);
  }
/**
 * Toggle expand state of [TdExpansionPanelComponent]
 * retuns 'true' if successful, else 'false'.
 * @return {?}
 */
toggle(): boolean {
    return this._setExpand(!this._expand);
  }
/**
 * Opens [TdExpansionPanelComponent]
 * retuns 'true' if successful, else 'false'.
 * @return {?}
 */
open(): boolean {
    return this._setExpand(true);
  }
/**
 * Closes [TdExpansionPanelComponent]
 * retuns 'true' if successful, else 'false'.
 * @return {?}
 */
close(): boolean {
    return this._setExpand(false);
  }
/**
 * Method to change expand state internally and emit the [onExpanded] event if 'true' or [onCollapsed]
 * event if 'false'. (Blocked if [disabled] is 'true')
 * @param {?} newExpand
 * @return {?}
 */
private _setExpand(newExpand: boolean): boolean {
    if (this._disabled) {
      return false;
    }
    if (this._expand !== newExpand) {
      this._expand = newExpand;
      if (newExpand) {
        this._onExpanded();
      } else {
        this._onCollapsed();
      }
      return true;
    }
    return false;
  }
/**
 * @return {?}
 */
private _onExpanded(): void {
    this.expanded.emit(undefined);
  }
/**
 * @return {?}
 */
private _onCollapsed(): void {
    this.collapsed.emit(undefined);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-expansion-panel',
  styleUrls: ['./expansion-panel.component.css' ],
  templateUrl: './expansion-panel.component.html',
  animations: [
    TdCollapseAnimation(),
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'expansionPanelHeader': [{ type: ContentChild, args: [TdExpansionPanelHeaderDirective, ] },],
'expansionPanelLabel': [{ type: ContentChild, args: [TdExpansionPanelLabelDirective, ] },],
'expansionPanelSublabel': [{ type: ContentChild, args: [TdExpansionPanelSublabelDirective, ] },],
'label': [{ type: Input },],
'sublabel': [{ type: Input },],
'expand': [{ type: Input, args: ['expand', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'expanded': [{ type: Output },],
'collapsed': [{ type: Output },],
};
}

function TdExpansionPanelComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdExpansionPanelComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdExpansionPanelComponent.ctorParameters;
/** @type {?} */
TdExpansionPanelComponent.propDecorators;
/** @type {?} */
TdExpansionPanelComponent.prototype._expand;
/** @type {?} */
TdExpansionPanelComponent.prototype._disabled;
/** @type {?} */
TdExpansionPanelComponent.prototype.expansionPanelHeader;
/** @type {?} */
TdExpansionPanelComponent.prototype.expansionPanelLabel;
/** @type {?} */
TdExpansionPanelComponent.prototype.expansionPanelSublabel;
/**
 * label?: string
 * Sets label of [TdExpansionPanelComponent] header.
 * Defaults to 'Click to expand'
 * @type {?}
 */
TdExpansionPanelComponent.prototype.label;
/**
 * sublabel?: string
 * Sets sublabel of [TdExpansionPanelComponent] header.
 * @type {?}
 */
TdExpansionPanelComponent.prototype.sublabel;
/**
 * expanded?: function
 * Event emitted when [TdExpansionPanelComponent] is expanded.
 * @type {?}
 */
TdExpansionPanelComponent.prototype.expanded;
/**
 * collapsed?: function
 * Event emitted when [TdExpansionPanelComponent] is collapsed.
 * @type {?}
 */
TdExpansionPanelComponent.prototype.collapsed;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
